// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Osy","content":"styles_content__3Fovp","tableWrap":"styles_tableWrap__1cnsA"};